module.exports = __webpack_public_path__ + "static/media/16d-03_Noiromence-2-2016-400x300cm-(dos-paneles-200x300cm-oleo-sobre-madera.f417b8fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16d/16d-03_Noiromence-2-2016-400x300cm-(dos-paneles-200x300cm-oleo-sobre-madera.jpg
// module id = 199
// module chunks = 0